/* eslint react/prop-types: 0 */
import React, { useState, useMemo } from 'react';
import ConfigAccordionBase from '../../../components/3modules/Config/ConfigAccordionBase';
import { Text } from '../../../components/1elements';
import MapMarkerPicker from '../MapMarkerPicker';
import MarkerStyleSelector from '../../../components/3modules/Config/MarkerStyleSelector';
import MarkerListFullEditor from '../MarkerListFullEditor';

import './styles.scss';

const IndustryTypeMarkerConfigAccordion = ({
  onEditMode,
  defaultMarker,
  industryTypeList,
  industryTypeIcons,
  setIndustryTypeIcons,
  label = 'Industry Type Marker',
  emptyMessage = 'No industry type markers configured.'
}) => {
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

  const selectedMarker = useMemo(
    () => ({
      ...defaultMarker,
      ...industryTypeIcons[selectedRowIndex],
      color: industryTypeIcons[selectedRowIndex]?.color || defaultMarker?.color
    }),
    [industryTypeIcons, selectedRowIndex, defaultMarker]
  );

  const updateMarkerIcon = (data) => {
    setIndustryTypeIcons((prev) => {
      const prevValue = { ...defaultMarker, ...prev[selectedRowIndex] };
      const newList = [...prev];
      newList[selectedRowIndex] = {
        ...prevValue,
        icon: Number.isFinite(data?.icon) ? data.icon : prevValue?.icon,
        color: data?.color ?? prevValue?.color,
        style: data?.style || prevValue?.style
      };
      return newList;
    });
  };

  return (
    <ConfigAccordionBase
      className={'IndustryTypeMarkerConfigAccordion-root'}
      label={label}
      onEditMode={onEditMode}
    >
      {!onEditMode && !industryTypeIcons.length && (
        <Text type={'span'}>
          {emptyMessage}
          <br />
          Please enable edit mode to configure markers.
        </Text>
      )}
      <div>
        {onEditMode && <Text type={'h9'}>Marker</Text>}
        <MarkerListFullEditor
          markerSettings={industryTypeIcons}
          setMarkerSettings={setIndustryTypeIcons}
          selectList={industryTypeList}
          selectedRowIndex={selectedRowIndex}
          setSelectedRowIndex={setSelectedRowIndex}
          className={'IndustryTypeMarkerConfigAccordion-editorList'}
          onEditMode={onEditMode}
          defaultMarker={defaultMarker}
        />
      </div>
      {onEditMode &&
        selectedRowIndex !== null &&
        industryTypeIcons[selectedRowIndex] && (
          <>
            <div>
              <Text type={'h9'}>Marker Style</Text>
              <MarkerStyleSelector
                selectedRow={selectedRowIndex}
                options={industryTypeIcons}
                updateMarker={updateMarkerIcon}
              />
            </div>
            <div>
              <Text type={'h9'}>Color & Icon</Text>
              <MapMarkerPicker
                className={'IndustryTypeMarkerConfigAccordion-mapMarkerPicker'}
                selectedMarker={selectedMarker}
                updateMarker={updateMarkerIcon}
                showIcon={true}
                showColor={true}
                showName={false}
              />
            </div>
          </>
        )}
    </ConfigAccordionBase>
  );
};

export default IndustryTypeMarkerConfigAccordion;
